import SLSParametrosService from '@/services/SistemaDKP/SLSParametros.service';

const _cache = new Map();

function extractValue(res) {
  if (!res) return null;
  if (typeof res === 'string') return res;
  if (Array.isArray(res)) return extractValue(res[0]);
  if (typeof res === 'object') {
    return (
      res.valor
      || res.value
      || res.parametroValor
      || res.parametro_valor
      || res.url
      || res.URL
      || res.parametro
      || null
    );
  }
  return null;
}

export async function getParametro(paramName) {
  const key = `PARAM:${paramName}`;
  if (_cache.has(key)) return _cache.get(key);
  try {
    const svc = new SLSParametrosService();
    const data = await svc.findByDescricao(paramName);
    const val = extractValue(data);
    if (val) _cache.set(key, val);
    return val;
  } catch (e) {
    return null;
  }
}

export async function getTotvsBaseUrl(modeOverride) {
  const mode = modeOverride || process.env.VUE_APP_MODE_APP || 'development';
  const isProd = String(mode).toLowerCase() === 'production';
  const paramKey = isProd ? 'TOTVS_API_URL_PROD' : 'TOTVS_API_URL_HOMOL';

  const cacheKey = `TOTVS_BASE:${paramKey}`;
  if (_cache.has(cacheKey)) return _cache.get(cacheKey);

  const dbUrl = await getParametro(paramKey);
  if (dbUrl) {
    _cache.set(cacheKey, dbUrl);
    return dbUrl;
  }

  // // Fallback para .env antigo caso o parâmetro não exista
  // const envUrl = isProd
  //   ? process.env.VUE_APP_API_TOTVS_PROD
  //   : process.env.VUE_APP_API_TOTVS_HOMOLOG;

  // if (envUrl) {
  //   _cache.set(cacheKey, envUrl);
  // }
  return '';
}
